import { api } from '../../shared/api/client';
import type { Snapshot } from '../snapshots/api';
import type {
  Doctor,
  DuplicateMatch,
  Paged,
  Patient,
  PatientDoctor,
  PatientInput,
  PatientScope,
  PatientShare,
} from './types';

interface ListParams {
  scope?: PatientScope;
  search?: string;
  /** Админ: пациенты конкретного врача. */
  doctorId?: string;
  limit?: number;
  offset?: number;
}

export async function listPatients(params: ListParams = {}): Promise<Paged<Patient>> {
  const { data } = await api.get<Paged<Patient>>('/v1/patients', { params });
  return data;
}

export async function checkPatientDuplicates(phone: string): Promise<DuplicateMatch[]> {
  const { data } = await api.get<{ items: DuplicateMatch[] }>('/v1/patients/check', {
    params: { phone },
  });
  return data.items;
}

export async function getPatient(id: string): Promise<Patient> {
  const { data } = await api.get<Patient>(`/v1/patients/${id}`);
  return data;
}

export async function createPatient(body: PatientInput): Promise<Patient> {
  const { data } = await api.post<Patient>('/v1/patients', body);
  return data;
}

export async function updatePatient(id: string, body: PatientInput): Promise<Patient> {
  const { data } = await api.patch<Patient>(`/v1/patients/${id}`, body);
  return data;
}

export async function deletePatient(id: string): Promise<void> {
  await api.delete(`/v1/patients/${id}`);
}

export async function listPatientSnapshots(id: string): Promise<Paged<Snapshot>> {
  const { data } = await api.get<Paged<Snapshot>>(`/v1/patients/${id}/snapshots`);
  return data;
}

export async function listPatientDoctors(id: string): Promise<PatientDoctor[]> {
  const { data } = await api.get<{ items: PatientDoctor[] }>(`/v1/patients/${id}/doctors`);
  return data.items;
}

/** Назначить ведущего врача по e-mail (врач должен быть зарегистрирован). */
export async function assignDoctor(id: string, email: string): Promise<void> {
  await api.post(`/v1/patients/${id}/doctors`, { email });
}

export async function unassignDoctor(id: string, doctorId: string): Promise<void> {
  await api.delete(`/v1/patients/${id}/doctors/${doctorId}`);
}

export async function listDoctors(): Promise<Doctor[]> {
  const { data } = await api.get<{ items: Doctor[] }>('/v1/doctors');
  return data.items;
}

export async function listPatientShares(id: string): Promise<PatientShare[]> {
  const { data } = await api.get<{ items: PatientShare[] }>(`/v1/patients/${id}/shares`);
  return data.items;
}

/** Открыть коллеге просмотр карточки по его e-mail. */
export async function sharePatient(id: string, email: string): Promise<void> {
  await api.post(`/v1/patients/${id}/shares`, { email });
}

export async function unsharePatient(id: string, doctorId: string): Promise<void> {
  await api.delete(`/v1/patients/${id}/shares/${doctorId}`);
}
